// src/utils/ensureErrorResponse.js
//
// NZSC-3572: axios 에러의 response 를 보장한다.
//
// 네트워크 끊김·타임아웃·요청 취소에는 `error.response` 가 아예 없다. 그런데 스토어 액션
// 64곳이 catch 에서 `error.response.status` 를 그대로 읽어, 의도한 실패 처리 대신
// catch 안에서 TypeError 가 다시 터졌다 — 원인은 유실되고 화면은 멈춘다.
// (전용 정규화기 utils/normalizeAxiosError.js 가 있으나 어디에도 연결돼 있지 않다.)
//
// 호출부 64곳을 고치는 대신 api 인터셉터에서 한 번 채워 전부 의도한 분기로 가게 한다.
// `status: 0` = 서버 응답 자체가 없었음. 기존에 `error.response` 진리값을 보던 코드는
// status 0 이 falsy 라 판정이 바뀌지 않는다.

export default function ensureErrorResponse(error) {
  if (error && typeof error === "object" && !error.response) {
    error.response = { status: 0, data: null };
  }
  return error;
}
